import { toPlatePlugin } from '@udecode/plate/react';

import { BaseLineHeightPlugin } from '../lib';

export const LineHeightPlugin = toPlatePlugin(BaseLineHeightPlugin);
